module.exports = __webpack_public_path__ + "static/img/bg-wallet.009a4839.png";